import axios from 'axios'

// 基础变量配置，后端ip
export const environment: any = {
    // baseUrl: 'http://${BASE_URL}' + '/api/v1',
    // baseUrl: 'http://47.96.164.104:30001/api/v1'
    baseUrl: '/api/v1',
    // baseUrl: 'http://8.140.192.249:38001/api/v1'
    // baseUrl: 'http://192.168.0.8:8080/api/v1',
}

// 设置全局请求头 X-Region
export const setRegionCode = (code: string) => {
  axios.defaults.headers.common['X-Region'] = code
}


// Microsoft Entra ID (AAD) 配置 — 部署时替换占位符
export const aadConfig = {
  tenantId: '52cef324-7ee3-4345-80ae-eb117a033772',
  clientId: '334115db-2862-4739-84eb-3271d65928fc',
}
